module.exports = __webpack_public_path__ + "img/hdr.8be694bf.png";